export default __webpack_public_path__ + "static/media/dole-juice-bg@2x.eb0b2c66.png";